import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, isRef as _isRef, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "layout-topbar" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "p-link layout-topbar-menu-button layout-topbar-button" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-v" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "layout-topbar-menu hidden lg:flex origin-top" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "로그아웃", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "confirmation-content" }, [
  /*#__PURE__*/_createElementVNode("span", null, "로그아웃 하시겠습니까?")
], -1)


import { useCookies } from "vue3-cookies";
import axios from "axios";

const { cookies } = useCookies();

const __default__ = {
  name: "AdminTopBar",
  data() {
    return {
      displayConfirmation: false
    };
  },
  methods: {
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    onTopbarMenuToggle(event) {
      this.$emit('topbar-menu-toggle', event);
    },
    logout() {
      axios.post("/api/auth/logout", "", {
        headers: { "Authorization": `Bearer ${cookies.get("Authentication")}` }
      }).catch(function(err) {
        console.error(err);
        alert("서버에 접속할 수 없습니다.");
      });
      cookies.remove("Authentication");
      cookies.remove("Refresh");
      window.location.reload();
    },
    openLogoutConfirmation() {
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
  }
};
import logo_l from "@/assets/images/logo_l.png";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {


return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_styleclass = _resolveDirective("styleclass")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/admin",
        class: "layout-topbar-logo"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            alt: "Logo",
            src: _unref(logo_l),
            style: {"margin":"0 auto"}
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        class: "p-link layout-menu-button layout-topbar-button",
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onMenuToggle && _ctx.onMenuToggle(...args)))
      }, _hoisted_4),
      _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_5, _hoisted_7)), [
        [_directive_styleclass, {
        selector: '@next',
        enterClass: 'hidden',
        enterActiveClass: 'scalein',
        leaveToClass: 'hidden',
        leaveActiveClass: 'fadeout',
        hideOnOutsideClick: true,
      }]
      ]),
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "p-link layout-topbar-button",
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.openLogoutConfirmation && _ctx.openLogoutConfirmation(...args)))
          }, _hoisted_11)
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: "Logout",
      visible: _ctx.displayConfirmation,
      "onUpdate:visible": _cache[2] || (_cache[2] = $event => (_isRef(displayConfirmation) ? (displayConfirmation).value = $event : null)),
      style: {width: '280px'},
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "네",
          icon: "pi pi-check",
          onClick: _ctx.logout,
          class: "p-button-text",
          autofocus: ""
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "아니오",
          icon: "pi pi-times",
          onClick: _ctx.closeConfirmation,
          class: "p-button-text"
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_12
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})